<!-- Error indicator -->
<span *ngIf="hasError"
	  [matTooltip]="errorInfo.error_list.join(';') | strarrTranslate"
	  class="error-indicator">
	<mat-icon *ngIf="errorInfo.error_type === 'DANGER'"
			  class="error-mat-icon"
			  style="color: red">error</mat-icon>
	<mat-icon *ngIf="errorInfo.error_type === 'WARNING'"
			  class="error-mat-icon"
			  style="color: orange">warning</mat-icon>
	<mat-icon *ngIf="errorInfo.error_type === 'INFO'"
			  class="error-mat-icon"
			  style="color: dodgerblue">info</mat-icon>
</span>

<!-- VIEW MODE -->
<ng-container *ngIf="!isEditMode; else editMode">
	<ng-container [ngSwitch]="column.type">

		<!-- DTY_LIST -->
		<ng-container *ngSwitchCase="'DTY_LIST'">
			<span *ngIf="column.isPk"
				  #listPkTooltip="matTooltip"
				  [matTooltip]="value"
				  matTooltipDisabled
				  (mouseenter)="showTooltipIfTruncated($event, listPkTooltip)"
				  [style.width.px]="cellWidth"
				  class="text-nowrap pointer text-decoration-underline text-overflow-custom">
				{{ getListDisplayValue() }}
			</span>

			<ng-container *ngIf="!column.isPk && getRegexpErrorsWithTooltips(value, column, tableName) as validationResult">
             	<span [matTooltip]="(getListDisplayValue() ?? '') + (validationResult?.tooltips?.length ? '\n' + validationResult.tooltips.join(' - ') : '')"
					  [style.width.px]="cellWidth"
					  [ngClass]="validationResult?.class"
					  class="{{tableName === 'oemcc_monitor_view' ? 'span' : 'd-inline-block' }} text-nowrap text-overflow-custom">
					{{ getListDisplayValue() }}
             	</span>
			</ng-container>
		</ng-container>

		<!-- DTY_RADIO -->
		<ng-container *ngSwitchCase="'DTY_RADIO'">
			<i *ngIf="isTruthyValue(value)"
			   class="bi bi-record-circle"></i>
			<i *ngIf="!isTruthyValue(value)"
			   class="bi bi-circle"></i>
		</ng-container>

		<!-- DTY_YES_NO -->
		<ng-container *ngSwitchCase="'DTY_YES_NO'">
			<span *ngIf="value === 'Y'"
				  [style.width.px]="cellWidth">
				<mat-icon>check_small</mat-icon>
			</span>
		</ng-container>

		<ng-container *ngSwitchCase="'DTY_STATUS'">
			<span>
			<ng-container
				[ngSwitch]="row[column.columnName]">

				<ng-container *ngSwitchCase="'INFO'">
					<mat-icon class="dty-status-info"
							  matTooltip="{{ 'ST_INFO' | translate}}">check_circle
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'ERROR'">
					<mat-icon class="dty-status-error"
							  matTooltip="{{ 'ST_ERROR' | translate}}">error
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'WARNING'">
					<mat-icon class="dty-status-warning"
							  matTooltip="{{ 'ST_WARNING' | translate}}">warning
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'NEW'">
					<mat-icon class="dty-status-new"
							  matTooltip="{{ 'ST_NEW' | translate}}">fiber_new
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'OPEN'">
					<mat-icon class="dty-status-info"
							  matTooltip="{{ 'ST_OPEN' | translate}}">lock_open
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'REOPENED'">
					<mat-icon class="dty-status-warning"
							  matTooltip="{{ 'ST_REOPENED' | translate}}">lock_open
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'CLOSED'">
					<mat-icon class="dty-status-error"
							  matTooltip="{{ 'ST_CLOSED' | translate}}">lock
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'UPDATED'">
					<mat-icon class="dty-status-error"
							  matTooltip="{{ 'ST_UPDATED' | translate}}">info
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'STAGED'">
					<mat-icon class="dty-status-warning"
							  matTooltip="{{ 'ST_STAGED' | translate}}">inventory_2
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'SENT'">
					<mat-icon class="dty-status-info"
							  matTooltip="{{ 'ST_SENT' | translate}}">mark_email_read
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'READY'">
					<mat-icon class="dty-status-info"
							  matTooltip="{{ 'ST_READY' | translate}}">pending
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'DELETE'">
					<mat-icon class="dty-status-delete"
							  matTooltip="{{ 'ST_DELETE' | translate}}">delete</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'SENT_FAILED'">
					<mat-icon class="dty-status-delete"
							  matTooltip="{{ 'ST_SENT_FAILED' | translate}}">sms_failed</mat-icon>
				</ng-container>

        <ng-container *ngSwitchCase="'DELIVERED'">
					<mat-icon class="dty-status-info"
                    matTooltip="{{ 'ST_DELIVERED' | translate}}">mark_email_read</mat-icon>
				</ng-container>

				<ng-container *ngSwitchDefault>
					<mat-icon
						matTooltip="{{ 'ST_HELP' | translate}}">help
					</mat-icon>
				</ng-container>

			</ng-container>
			</span>
		</ng-container>


		<!-- DTY_CUSTOM -->
		<ng-container *ngSwitchCase="'DTY_CUSTOM'">
			<ng-container *ngIf="getCustomComponent() as component">
				<ng-container appCustomComponentHost
							  [component]="component"
							  [(value)]="row[column.columnName]"
							  [extraInputs]="{
								placeholder: column.placeholder,
								editable: false,
								options: column.options,
								disabled: disabled,
								rowData: row,
								column: column
							  }"
							  (valueChange)="onValueChange($event)">
				</ng-container>
			</ng-container>
		</ng-container>

		<!-- DEFAULT (text, numbers, etc.) -->
		<ng-container *ngSwitchDefault>

			<ng-container *ngIf="getRegexpErrorsWithTooltips(value, column, tableName) as validationResult">
             <span [matTooltip]="(value|| '') + (validationResult?.tooltips?.length ? '\n' + validationResult.tooltips.join(' - ') : '')"
				   [ngClass]="validationResult?.class"
				   [style.width.px]="cellWidth"
				   class="span text-nowrap text-overflow-custom">
                {{ value }}
              </span>
			</ng-container>
		</ng-container>

	</ng-container>
</ng-container>

<!-- EDIT MODE -->
<ng-template #editMode>
	<ng-container [ngSwitch]="column.type">

		<!-- Text/Number fields -->
		<ng-container *ngSwitchCase="'DTY_NVAR'">
			<custom-text-field
				[(value)]="row[column.columnName]"
				[columnId]="column.id"
				[disabled]="disabled"
				[isNumber]="false"
				[columnType]="column.type"
				[maxlength]="column.maxLength"
				[mywidth]="cellWidth"
				[onError]="errors?.[column.columnName]"
				[pattern]="column.patternInfo || ''"
				[regexps]="column.regExpList || []"
				(change)="onValueChange(row[column.columnName])"
				(onErrorChange)="onErrorChange($event)">
			</custom-text-field>
		</ng-container>

		<ng-container *ngSwitchCase="'DTY_INT'">
			<custom-text-field
				[(value)]="row[column.columnName]"
				[columnId]="column.id"
				[disabled]="disabled"
				[isNumber]="true"
				[columnType]="column.type"
				[maxlength]="column.maxLength"
				[mywidth]="cellWidth"
				[onError]="errors?.[column.columnName]"
				[pattern]="column.patternInfo || ''"
				[regexps]="column.regExpList || []"
				(change)="onValueChange(row[column.columnName])"
				(onErrorChange)="onErrorChange($event)">
			</custom-text-field>
		</ng-container>

		<ng-container *ngSwitchCase="'DTY_FLOAT'">
			<custom-text-field
				[(value)]="row[column.columnName]"
				[columnId]="column.id"
				[disabled]="disabled"
				[isNumber]="true"
				[columnType]="column.type"
				[maxlength]="column.maxLength"
				[mywidth]="cellWidth"
				[onError]="errors?.[column.columnName]"
				[pattern]="column.patternInfo || ''"
				[regexps]="column.regExpList || []"
				(change)="onValueChange(row[column.columnName])"
				(onErrorChange)="onErrorChange($event)">
			</custom-text-field>
		</ng-container>

		<!-- List/Select -->
		<ng-container *ngSwitchCase="'DTY_LIST'">
			<ng-container *ngIf="!isNewRow || !column.isPk; else listTextField">
				<custom-ext-select
					[(defaultValue)]="row[column.columnName]"
					[disabled]="disabled"
					[values]="filterValues[column.columnName] || []"
					[searchable]="true"
					(defaultValueChange)="onValueChange(row[column.columnName])">
				</custom-ext-select>
			</ng-container>
			<ng-template #listTextField>
				<custom-text-field
					[(value)]="row[column.columnName]"
					[disabled]="disabled"
					[isNumber]="false"
					[columnType]="column.type"
					[maxlength]="column.maxLength"
					[mywidth]="cellWidth"
					[onError]="errors?.[column.columnName]"
					[pattern]="column.patternInfo || ''"
					[regexps]="column.regExpList || []"
					(change)="onValueChange(row[column.columnName])"
					(onErrorChange)="onErrorChange($event)">
				</custom-text-field>
			</ng-template>
		</ng-container>

		<!-- Date -->
		<ng-container *ngSwitchCase="'DTY_DATE'">
			<custom-datepicker
				[(value)]="row[column.columnName]"
				[disabled]="disabled"
				(valueChange)="onValueChange($event)">
			</custom-datepicker>
		</ng-container>

		<!-- Yes/No Checkbox -->
		<ng-container *ngSwitchCase="'DTY_YES_NO'">
			<custom-checkbox
				[(ngModel)]="row[column.columnName]"
				[trueValue]="'Y'"
				[falseValue]="'N'"
				(ngModelChange)="onValueChange($event)">
			</custom-checkbox>
		</ng-container>

		<!-- Radio -->
		<ng-container *ngSwitchCase="'DTY_RADIO'">
			<ng-container *ngIf="isTruthyValue(value); else uncheckedRadio">
				<svg (click)="onRadioClick()"
					 height="16"
					 width="16"
					 viewBox="0 0 1080 1080"
					 class="pointer">
					<circle cx="540"
							cy="540"
							r="480"
							fill="white"
							stroke="#011e41"
							stroke-width="60"/>
					<circle cx="540"
							cy="540"
							r="200"
							fill="#011e41"/>
				</svg>
			</ng-container>
			<ng-template #uncheckedRadio>
				<svg (click)="onRadioClick()"
					 height="16"
					 width="16"
					 viewBox="0 0 1080 1080"
					 class="pointer">
					<circle cx="540"
							cy="540"
							r="480"
							fill="white"
							stroke="#011e41"
							stroke-width="60"/>
				</svg>
			</ng-template>
		</ng-container>

		<ng-container *ngSwitchCase="'DTY_STATUS'">
		<span>
			<ng-container
				[ngSwitch]="row[column.columnName]">

				<ng-container *ngSwitchCase="'INFO'">
					<mat-icon class="dty-status-info"
							  matTooltip="{{ 'ST_INFO' | translate}}">check_circle
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'ERROR'">
					<mat-icon class="dty-status-error"
							  matTooltip="{{ 'ST_ERROR' | translate}}">error
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'WARNING'">
					<mat-icon class="dty-status-warning"
							  matTooltip="{{ 'ST_WARNING' | translate}}">warning
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'NEW'">
					<mat-icon class="dty-status-new"
							  matTooltip="{{ 'ST_NEW' | translate}}">fiber_new
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'OPEN'">
					<mat-icon class="dty-status-info"
							  matTooltip="{{ 'ST_OPEN' | translate}}">lock_open
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'REOPENED'">
					<mat-icon class="dty-status-warning"
							  matTooltip="{{ 'ST_REOPENED' | translate}}">lock_open
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'CLOSED'">
					<mat-icon class="dty-status-error"
							  matTooltip="{{ 'ST_CLOSED' | translate}}">lock
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'UPDATED'">
					<mat-icon class="dty-status-error"
							  matTooltip="{{ 'ST_UPDATED' | translate}}">info
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'STAGED'">
					<mat-icon class="dty-status-warning"
							  matTooltip="{{ 'ST_STAGED' | translate}}">inventory_2
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'SENT'">
					<mat-icon class="dty-status-info"
							  matTooltip="{{ 'ST_SENT' | translate}}">mark_email_read
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'READY'">
					<mat-icon class="dty-status-info"
							  matTooltip="{{ 'ST_READY' | translate}}">pending
					</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'DELETE'">
					<mat-icon class="dty-status-delete"
							  matTooltip="{{ 'ST_DELETE' | translate}}">delete</mat-icon>
				</ng-container>

				<ng-container *ngSwitchCase="'SENT_FAILED'">
					<mat-icon class="dty-status-delete"
							  matTooltip="{{ 'ST_SENT_FAILED' | translate}}">sms_failed</mat-icon>
				</ng-container>

        <ng-container *ngSwitchCase="'DELIVERED'">
					<mat-icon class="dty-status-info"
                    matTooltip="{{ 'ST_DELIVERED' | translate}}">mark_email_read</mat-icon>
				</ng-container>

				<ng-container *ngSwitchDefault>
					<mat-icon
						matTooltip="{{ 'ST_HELP' | translate}}">help
					</mat-icon>
				</ng-container>

			</ng-container>
			</span>
		</ng-container>

		<ng-container *ngSwitchCase="'DTY_TIME'">
			<custom-timepicker (valueChange)="onValueChange($event)" [(value)]="row[column.columnName]" [disabled]="disabled"></custom-timepicker>
		</ng-container>

		<!-- Custom -->
		<ng-container *ngSwitchCase="'DTY_CUSTOM'">
			<ng-container *ngIf="getCustomComponent() as component">
				<ng-container appCustomComponentHost
							  [component]="component"
							  [(value)]="row[column.columnName]"
							  [extraInputs]="{
								placeholder: column.placeholder,
								editable: true,
								options: column.options,
								disabled: disabled,
								rowData: row,
								column: column
							  }"
							  (valueChange)="onValueChange($event)">
				</ng-container>
			</ng-container>
		</ng-container>

	</ng-container>
</ng-template>
